import type { RatingValue, TaskMemberConfirmationStatus } from '@frontend/api-types';

export const TASK_CATEGORY_ICON_MAP = {
  'Account & Tech Support': 'IconFileCertificate',
  'Activity Scheduling & Rentals': 'IconMoodKid',
  'Administrative & Document Tasks': 'IconClipboardData',
  'Airport & Local Transfers': 'IconBeach',
  'Apparel & Fashion Searches': 'IconShoppingCart',
  'Auto Repair & Dealership Services': 'IconCar',
  'Baby & Kid Gift Ideas': 'IconShoppingCart',
  'Beauty & Salon Services': 'IconScissors',
  'Bill Payments & Fees': 'IconFileCertificate',
  'Billing Issues & Charge Disputes': 'IconFileCertificate',
  'Birthday & Anniversary Gifting': 'IconGift',
  'Birthdays & Reminder Alerts': 'IconCalendarEvent',
  'Business & Financial Research': 'IconClipboardData',
  'Calendar & Event Management': 'IconCalendarEvent',
  'Car Rentals & Parking': 'IconBeach',
  'Catering & Private Dining': 'IconToolsKitchen3',
  'Child & Youth Program Registrations': 'IconMoodKid',
  'Childcare & Family Assistance': 'IconMoodKid',
  'Cleaning & Laundry Services': 'IconTool',
  'Clothing & Footwear Orders': 'IconShoppingCart',
  'Content Creation & Editing': 'IconClipboardData',
  'Custom Gift Tags & Stationery': 'IconGift',
  'DMV & License Processes': 'IconCar',
  'Data Research & Compilation': 'IconClipboardData',
  'Date & Anniversary Plans': 'IconToolsKitchen3',
  'Dental & Orthodontic Queries': 'IconStethoscope',
  'Doctor Searches & Specialist Info': 'IconStethoscope',
  'Donations & Pickups': 'IconTruck',
  'Duckbill Support': 'IconMessageCircleUser',
  'Electronics & Product Research': 'IconShoppingCart',
  'Event & Class Cancellations': 'IconShoppingBagX',
  'Event & Entertainment Ticketing': 'IconTicket',
  'Family Flight Requests': 'IconPlaneTilt',
  'Family-Friendly Activities & Trips': 'IconToolsKitchen3',
  'Flight Bookings & Coordination': 'IconBeach',
  'Flight Cancellations & Refunds': 'IconPlaneTilt',
  'Flower & Gift Deliveries': 'IconGift',
  'Food & Beverage Orders': 'IconSalad',
  'Frequent Flyer & Flight Changes': 'IconMoodKid',
  'Government & Utility Tasks': 'IconFileCertificate',
  'Grocery Delivery & Meal Orders': 'IconSalad',
  'Group & Event Restaurant Reservations': 'IconToolsKitchen3',
  'Hair & Salon Bookings': 'IconScissors',
  'Handyman & Home Fixes': 'IconTool',
  'Health Insurance & Claims': 'IconFileCertificate',
  'Home Decor & Interior Design': 'IconShoppingCart',
  'Home Goods & Kitchenware': 'IconShoppingCart',
  'Home Repairs & Contractor Quotes': 'IconTool',
  'Home Water Filters & Parts': 'IconTool',
  'Hotel Bookings & Stays': 'IconBeach',
  'Insurance Policies & Quotes': 'IconShieldCheck',
  'International Travel Research': 'IconToolsKitchen3',
  'Kids’ Clothing & Gear': 'IconShoppingCart',
  'Kids’ Events & Calendar Sync': 'IconCalendarEvent',
  'Landscaping & Yard Work': 'IconTool',
  'Legal & Tax Professionals': 'IconClipboardData',
  'Lessons & Classes Scheduling': 'IconMoodKid',
  'Local Events & Family Activities': 'IconToolsKitchen3',
  'Lodging & Accommodation Searches': 'IconBeach',
  'Maintenance & Service Appointments': 'IconTool',
  'Meal Planning & Recipes': 'IconSalad',
  'Membership & Subscription Cancellations': 'IconShoppingBagX',
  'Misc. Calendar Entries & Invites': 'IconCalendarEvent',
  'Misc. Medical Appointment Bookings': 'IconStethoscope',
  'Misc. Travel Itineraries & Plans': 'IconToolsKitchen3',
  'Moving & Freight Services': 'IconTruck',
  'Occasion & Personalized Gifts': 'IconGift',
  'Online Purchase Returns': 'IconShoppingCartSearch',
  'Order Tracking & Shipping': 'IconShoppingCartSearch',
  'Other Appointment Changes & Cancellations': 'IconStethoscope',
  'Other. Undefined or Rare tasks.': 'IconFileCertificate',
  'Outdoor & Recreational Bookings': 'IconBeach',
  'Parenting & Kid Resources': 'IconTool',
  'Party & Celebration Planning': 'IconToolsKitchen3',
  'Passport & Vital Records': 'IconGlobe',
  'Payment Disputes & Refund Requests': 'IconShoppingCartSearch',
  'Pediatric Appointments & Checkups': 'IconStethoscope',
  'Personal Dinner Reservations & Bookings': 'IconToolsKitchen3',
  'Personal Finance & Credit FAQs': 'IconFileCertificate',
  'Personal Gift Suggestions': 'IconGift',
  'Pest Control & Eco Solutions': 'IconTool',
  'Pet Care & Vet Visits': 'IconMoodKid',
  'Pharmacy & Prescription Orders': 'IconStethoscope',
  'Photos & Printing Projects': 'IconLibraryPhoto',
  'Product Advice & Recommendations': 'IconShoppingCart',
  'Recurring Tasks & Reminders': 'IconCalendarEvent',
  'Repair, Tailoring & Styling Services': 'IconScissors',
  'Restaurant Suggestions & Dining Info': 'IconToolsKitchen3',
  'Retail & Brand Inquiries': 'IconShoppingCartSearch',
  'Spa & Massage Reservations': 'IconScissors',
  'Therapy & Counseling Requests': 'IconStethoscope',
  'Travel Documents & Visa Help': 'IconGlobe',
  'Warranties & Product Replacements': 'IconShoppingCartSearch',
  'Wellness & Health Routines': 'IconHeartbeat',
} as const satisfies Record<string, string>;

export const TASK_NOT_DONE_REASON_ICON_MAP = {
  "Duckbill didn't understand what I needed": 'IconBulbOff',
  'I changed my mind': 'IconRefresh',
  'I took it over myself': 'IconPointer',
  'It felt too complicated / confusing': 'IconArrowFork',
  'It was taking too long': 'IconHourglassLow',
  "It's no longer relevant": 'IconBan',
} as const satisfies Record<string, string>;

export type TaskNotDoneReason = keyof typeof TASK_NOT_DONE_REASON_ICON_MAP;

export const TASK_NOT_DONE_REASONS = Object.keys(TASK_NOT_DONE_REASON_ICON_MAP) as TaskNotDoneReason[];

export type TaskMemberConfirmationStatusOption = Exclude<TaskMemberConfirmationStatus, 'skipped'>;

export const TASK_MEMBER_CONFIRMATION_STATUS_OPTIONS = [
  {
    description: 'Confirm the task is successfully completed.',
    id: 'Mark as done',
    label: 'Mark as done',
    value: 'done',
  },
  {
    description: 'Close an incomplete task to remove it from your in-progress list.',
    id: 'Close as incomplete',
    label: 'Close as incomplete',
    value: 'not_done',
  },
] as const satisfies {
  description: string;
  id: string;
  label: string;
  value: TaskMemberConfirmationStatusOption;
}[];

export const TASK_RATING_TO_EMOJI_MAP = {
  1: '😖',
  2: '☹️',
  3: '😐',
  4: '😄',
  5: '🤩',
} satisfies { [key in RatingValue]: string };

export const RATING_OPTIONS = [1, 2, 3, 4, 5] satisfies [
  RatingValue,
  RatingValue,
  RatingValue,
  RatingValue,
  RatingValue,
];
